"use strict";
// Validates that a country is not blocked.
function blockedCountryValidator() {
    return function (control) {
        var value = control.value;
        if (value && value.isBlocked) {
            return { 'blocked': value };
        }
        return null;
    };
}
exports.blockedCountryValidator = blockedCountryValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/blocked-country.validator.js